//******************** Playground Validation JS conflict with our
//Flows and login pages so IT requested to remove it. Plus we use sitecore forms, so this is not needed anyways.

jQuery(function(){

    //? on form submit
    jQuery(".form__cta-anchor").on('click', function () {
        //? get closest form tag and scroll to it
        var $formID = jQuery(this).closest("form");
        jQuery(document).scrollTop($formID.offset().top);
    });

// 	function getEleType($element) {
// 		switch($element.prop('type')) {

// 			case 'select':
// 				type = 'select';
// 				break;
// 			case 'select-one':
// 				type = 'select';
// 				break;
// 			case 'radio':
// 				type = 'radio';
// 				break;
// 			case 'textarea':
// 				type = 'textarea';
// 				break;
// 			default:
// 				type = 'text';
// 		}

// 		return type;
// 	}

// 	if(jQuery('.form--validate').length > 0) {

// 		// Init forms for validation
// 		jQuery('.form--validate').each(function(index, form){
// 			var $form = jQuery(form);

// 			$form.parsley().on('field:validate', function(element){
// 				var $element = element.$element;
// 				var type = getEleType($element);

// 				var $container = $element.parent('.input__' + type +'-container');
// 				$container.addClass('input__' + type + '-container--error');

// 				// Special case for radio buttons.  Only display error message on the last one
// 				if(type == 'radio') {
// 					var name = $element.attr('name');

// 					if(!jQuery('input[name="' + name + '"]').is(':checked')) {
// 						$container = $element.closest('.input__radio').siblings(':last');
// 						$container.find('.input__radio-container').addClass('input__radio-container--error');
// 					}
// 				}

// 			}).on('field:success', function(element){
// 				var $element = element.$element;
// 				var type = getEleType($element);
// 				var $container = $element.parent('.input__' + type + '-container');

// 				if(type == 'select') {
// 					if($element.val() !== '')
// 						$container.removeClass('input__' + type + '-container--error');
// 				} else {
// 					$container.removeClass('input__' + type + '-container--error');
// 				}

// 			});
// 		});


// 	}

});


